const findOne = (selector, element = document) => element.querySelector(selector);

export default el => {
  const link = `${el.getAttribute('href')}?search=`;
  const input = findOne('.searchInput', el);
  const startvalues = {};
  const iconText = findOne('.searchIconText', el);
  const iconTextInner = iconText.innerHTML;

  const searchString = document.location.search.substring(1).split('&').reduce((output, value) => {
    const paramValue = value.split('=');
    output[paramValue[0]] = decodeURIComponent(paramValue[1]);
    return output;
  }, {}).search;

  if (searchString) {
    input.value = searchString;
    if (window.matchMedia('(min-width: 600px)').matches) {
      input.classList.add('searchInput--active');
    }
  }

  el.addEventListener('click', e => {
    e.preventDefault();
    if (input.value.trim() !== '' && window.matchMedia('(min-width: 600px)').matches && e.target !== input) {
      window.location.href = `${link}${encodeURI(input.value.trim())}`;
    } else if (input.value.trim() !== '' && el.classList.contains('searchLink--active') && e.target.classList.contains('fa-search')) {
      window.location.href = `${link}${encodeURI(input.value.trim())}`;
    } else if (window.matchMedia('(min-width: 600px)').matches && e.target !== input) {
      if (!input.classList.contains('searchInput--active')) {
        input.focus();
      }
      input.classList.toggle('searchInput--active');
    } else {
      const box = el.getBoundingClientRect();
      if (e.target !== input) {
        if (!el.classList.contains('searchLink--active')) {
          document.body.classList.add('body--noScroll');

          startvalues.top = box.top;
          startvalues.left = box.left;

          el.style.top = `${box.top}px`;
          el.style.left = `${box.left}px`;

          el.classList.add('searchLink--active');

          setTimeout( () => {
            iconText.innerHTML = '<i class="fa fa-times fa-3x"></i>'
            el.style.top = null;
            el.style.left = null;
          }, 0);

          input.focus();
        } else if (e.target.classList.contains('fa-times')) {
          document.body.classList.remove('body--noScroll');
          el.style.top = `${startvalues.top}px`;
          el.style.left = `${startvalues.left}px`;
          el.classList.add('searchLink--animate');
          el.classList.remove('searchLink--active');

          iconText.innerHTML = iconTextInner;

          setTimeout(() => {
            el.classList.remove('searchLink--animate');
            el.style.top = null;
            el.style.left = null;
          }, 600);
        }
      }
    }
  });

  input.addEventListener('keyup', (e) => {
    if (e.which === 13 || e.keyCode === 13) {
      if (input.value.trim() !== '') {
        window.location.href = `${link}${encodeURI(input.value.trim())}`;
      }
    }
  });
}
